import styled, { css, keyframes } from 'styled-components';

import { Wrapper as Button } from '@spa/shared/components/Unisystem/Button/styles';
import { Wrapper as StatusBanner } from '@spa/shared/components/Unisystem/StatusBanner/styles';
import { Wrapper as ReserveWarning } from '@spa/shared/components/ReserveWarning/styles';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const slideIn = keyframes`
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`;

const upSmooth = keyframes`
  from {
    opacity: 0.75;
    transform: translateY(650px);
  }
  to {
    opacity: 1;
    transform: translateY(0px);
  }
`;

export const WrapperDesktop = styled.div`
  position: relative;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.space(3)};
  position: absolute;
  top: 0;
  right: 0;
  width: ${props => (props.isBig ? '754px' : '500px')};
  padding: ${props => props.theme.space(8)};
  background: ${props => props.theme.unisystem.calendar.background};
  box-shadow: 20px 5px 30px 0px ${props => props.theme.unisystem.calendar.shadow};
  z-index: 1;
  border-radius: 12px;
  border: 1px solid ${props => props.theme.unisystem.calendar.borderColor};
  animation: ${slideIn} 0.3s ease-out, ${fadeIn} 0.3s ease-out;
  overflow-y: auto;

  .close-icon {
    display: block;
    width: 15px;
    height: 15px;
    position: absolute;
    top: 24px;
    right: 31px;
  }
`;

export const WrapperMobile = styled(WrapperDesktop)`
  position: fixed;
  width: 100%;
  height: 100dvh;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: ${props => props.theme.space(5)};
  padding-bottom: 130px;
  overflow-y: ${props => (props.showPaymentSummary ? 'auto' : 'hidden')};
  animation: ${upSmooth} 0.45s ease-out;

  ${ReserveWarning} {
    font-size: ${props => props.theme.rem(12)};
    line-height: ${props => props.theme.rem(24)};
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${({ hasSingleChild }) => (hasSingleChild ? 'flex-end' : 'space-between')};
  width: 100%;
  min-height: min-content;

  & > ${Button} {
    border: none;
    text-decoration: underline ${props => props.theme.buttons.tertiary.color};
    padding: 0;

    span {
      color: ${props => props.theme.buttons.tertiary.color};
    }
  }

  svg {
    cursor: pointer;
    border-radius: 50%;
    z-index: 1;
    background: transparent;
    padding: ${props => props.theme.space(2)};
    margin-left: ${props => props.theme.space(-2)};
    width: 36px;
    height: 36px;

    > path {
      fill: ${props => props.theme.colors.cornFlowerBlue};
    }

    &:hover {
      background: ${props => props.theme.closeButton.background};
    }
  }
`;

export const ButtonsDesktop = styled.div`
  display: flex;
  justify-content: flex-end;
  align-self: flex-end;
  gap: ${props => props.theme.space(3)};
  margin-top: auto;

  ${Button} {
    min-width: 120px;
    width: fit-content;

    &:only-child {
      width: 100%;
    }
  }
`;

export const ButtonsMobile = styled(ButtonsDesktop)`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 64px;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${props => props.theme.space(3)};
  border-top: 1px solid ${props => props.theme.colors.shadyGray};
  background: white;

  ${props =>
    props.showPaymentSummary &&
    css`
      flex-direction: column;
      height: auto;
      padding: ${props.theme.space(5)};
      ${({ theme }) => theme.gap(2, 'column')}

      ${Button} {
        width: 100%;
      }

      ${StatusBanner} {
        padding: 0;
      }
    `}

  ${Button}:only-child {
    justify-content: center;
  }
`;
